"use client";

import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: labelRef,
    isVisible: labelVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const [headlineMounted, setHeadlineMounted] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const timer = setTimeout(() => setHeadlineMounted(true), 100);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxOffset = Math.min(scrollY * 0.15, 40);
  return <section data-section-id="2778" id="heroservices" className="bg-background text-foreground relative overflow-hidden min-h-[110vh] flex items-center">
      <div className="w-full max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28">
        <div className="grid grid-cols-12 gap-x-4 md:gap-x-6 gap-y-12 md:gap-y-16">
          {}
          <div ref={labelRef} className={`col-span-12 md:col-span-2 transition-all duration-1000 ease-out ${labelVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <p className="font-default text-xs md:text-sm uppercase tracking-widest text-primary">
              SERVIZI LIONIA
            </p>
          </div>

          {}
          <div className="col-span-12 md:col-span-9 md:col-start-2">
            <h1 className={`font-default font-bold text-foreground transition-all duration-1000 ease-out ${headlineMounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`} style={{
            fontSize: "clamp(48px, 11vw, 168px)",
            lineHeight: "0.92",
            letterSpacing: "-0.02em"
          }}>
              Strategia.<br />Visione.<br />Coraggio.
            </h1>
          </div>

          {}
          <div ref={paragraphRef} className={`col-span-12 md:col-span-5 md:col-start-2 transition-all duration-1000 ease-out delay-300 ${paragraphVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <p className="font-default text-lg leading-relaxed text-muted-foreground mb-8 max-w-xl">
              Servizi per brand, founder e aziende che vogliono comunicare con precisione: audit, identità, contenuti, sito, AI e percorsi formativi.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link to="/ServicesPage">
                <Button size="lg" className="rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 px-7 h-12 font-default text-sm font-bold tracking-wide shadow-md">
                  Guarda i servizi +
                </Button>
              </Link>
              <Link to="/ContactsPage">
                <Button variant="outline" size="lg" className="rounded-lg border-foreground/20 hover:bg-foreground/5 px-7 h-12 font-default text-sm font-bold tracking-wide">
                  Richiedi preventivo
                </Button>
              </Link>
            </div>
          </div>

          {}
          
        </div>
      </div>

      {}
      <div aria-hidden="true" className="absolute left-0 right-0 bottom-0 h-px bg-border/50" />
    </section>;
}